import React from 'react';
import Menu from './menu';
import Logo from './logo';
import LanguageList from './languagelist';
import Navigation from './navigation';

const Header = (props) => {
    return (
        <header id="topnav">
            <div className={ props.homepage ? "topbar-main bg-transparent" : "topbar-main" }>
                <div className="container-fluid">
                    <Menu id={ props.homepage ? "menu-item-white" : "menu-item-dark" } />
                    <Logo logo={ props.homepage ? "logo-lg text-white" : "logo-lg" } />
                    <LanguageList id={ props.homepage ? "language-item-white" : "language-item-dark" } 
                            color={ props.homepage ? "text-white" : "" }
                            btnColor={ props.homepage ? "btn-bordered  btn-white" : "btn-primary" } />
                    <Navigation color={ props.homepage ? "text-white" : "text-custom" }/>
                    <div className="clearfix"></div>
                </div>
            </div>
        </header>
    );
}

export default Header;